module.exports = __webpack_public_path__ + "img/cp73-r1.faceb2ec.jpg";